import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const EditIcon = ({ stroke, fill, active, className,...props }) => {
  const useStyles = makeStyles({
    a: {
      fill: fill || "#24d7d3",
    },
  });
  const classes = useStyles();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.506"
      height="11.494"
      viewBox="0 0 11.506 11.494"
      className={className}
    >
      <g transform="translate(0 0)">
        <path
          className={classes.a}
          d="M7.105,82.636.775,88.967a.252.252,0,0,0-.066.116L.007,91.9a.249.249,0,0,0,.242.31.248.248,0,0,0,.06-.007l2.816-.7a.249.249,0,0,0,.116-.066L9.572,85.1Z"
          transform="translate(0 -80.715)"
        />
        <path
          className={classes.a}
          d="M337.324,1.55l-.7-.7a1.276,1.276,0,0,0-1.762,0l-.863.863,2.467,2.467.863-.863a1.247,1.247,0,0,0,0-1.762Z"
          transform="translate(-326.183 -0.493)"
        />
      </g>
    </svg>
  );
};

export default EditIcon;
